import { getPlayerAssetsByKeys } from "../../lib/bundle_helper";

document.addEventListener("DOMContentLoaded", function () {
  const manifestPath = [
    "viewer-v2",
    process.env.PLAYER_V2_SUB_DIR_PATH ?? "",
    "manifest.json"
  ]
    .filter(Boolean)
    .join("/");
  getPlayerAssetsByKeys(manifestPath, ["src/embededApp.tsx"]);
});
